import React from 'react';
import { Card, CardContent, CardHeader, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    border: 'none',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: theme.spacing(2),
  },
  image: {
    width: '6rem',
    height: 'auto',
    margin: '0 auto',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    fontSize: '0.875rem',
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  description: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    maxWidth: '16rem',
    margin: '0 auto',
  },
}));

const LearningStrategyCard = ({ className, strategy }) => {
  const classes = useStyles();

  return (
    <div className={className}>
      <Card className={classes.card}>
        <CardHeader
          className={classes.header}
          avatar={
            <img
              src={strategy.image}
              alt={strategy.title}
              className={classes.image}
            />
          }
          title={
            <Typography variant="h6" className={classes.title}>
              {strategy.title}
            </Typography>
          }
        />
        <CardContent>
          <Typography className={classes.subtitle}>
            {strategy.subtitle}
          </Typography>
          <Typography className={classes.description}>
            {strategy.description}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default LearningStrategyCard; 